<template>
  <div class="tab-container">
    <div class="tab" ref="tab">
      <span
        class="tab-item"
        :class="{active: index === value}"
        v-for="(item, index) in list"
        :key="index"
        @click="handleChange(item, index)"
        ref="item"
      >
        {{item}}
      </span>
    </div>
    <i class="line" :style="{'--translateX': translateX + 'px'}" ref="line"></i>
  </div>
</template>

<script>
export default {
  name: 'tab',
  props: {
    list: Array,
    value: Number
  },
  data () {
    return {
      translateX: {}
    }
  },
  mounted () {
    this.setTransformX(this.value, 1)
    this.$watch('value', function (value) {
      this.setTransformX(value)
    })
  },
  model: {
    event: 'change'
  },
  methods: {
    handleChange (item, index) {
      if (this.current !== index) {
        this.$emit('change', index, item)
      }
    },
    setTransformX (value = 0, ratio = 1.2) {
      const item = this.$refs.item[value]
      const x = this.getTransformX(item, ratio)
      this.translateX = x;
    },
    getTransformX (dom, ratio) {
      const {
        tab,
        line
      } = this.$refs
      const tabX = tab.getBoundingClientRect().x
      const lineWidth = line.getBoundingClientRect().width
      const domSize = dom.getBoundingClientRect()
      return domSize.x - tabX - lineWidth / 2 + (domSize.width / 2 * ratio)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-container {
  .tab {
    .tab-item {
      font-size: 26px;
      transition: transform .2s linear;
      transform-origin: center left;
      display: inline-block;
      &:not(:last-child) {
        margin-right: 70px;
      }
      &.active {
        transform: scale(1.2);
        color: rgb(86, 114, 240);
      }
    }
  }
  .line {
    width: 30px;
    height: 6px;
    background: rgb(86, 114, 240);
    display: inline-block;
    border-radius: 3px;
    transition: transform .2s ease-out;
    transform: translateX(var(--translateX));
  }
}
</style>
